var map = {
	"./icon-admin.svg": "./src/icons/svg/icon-admin.svg",
	"./icon-bianji.svg": "./src/icons/svg/icon-bianji.svg",
	"./icon-config.svg": "./src/icons/svg/icon-config.svg",
	"./icon-dangdifill.svg": "./src/icons/svg/icon-dangdifill.svg",
	"./icon-daohang.svg": "./src/icons/svg/icon-daohang.svg",
	"./icon-duanxin.svg": "./src/icons/svg/icon-duanxin.svg",
	"./icon-editor.svg": "./src/icons/svg/icon-editor.svg",
	"./icon-factory2.svg": "./src/icons/svg/icon-factory2.svg",
	"./icon-form.svg": "./src/icons/svg/icon-form.svg",
	"./icon-geren.svg": "./src/icons/svg/icon-geren.svg",
	"./icon-jiesuo.svg": "./src/icons/svg/icon-jiesuo.svg",
	"./icon-job.svg": "./src/icons/svg/icon-job.svg",
	"./icon-log.svg": "./src/icons/svg/icon-log.svg",
	"./icon-menu.svg": "./src/icons/svg/icon-menu.svg",
	"./icon-mudedi.svg": "./src/icons/svg/icon-mudedi.svg",
	"./icon-order.svg": "./src/icons/svg/icon-order.svg",
	"./icon-oss.svg": "./src/icons/svg/icon-oss.svg",
	"./icon-packing.svg": "./src/icons/svg/icon-packing.svg",
	"./icon-pinglun.svg": "./src/icons/svg/icon-pinglun.svg",
	"./icon-prod.svg": "./src/icons/svg/icon-prod.svg",
	"./icon-role.svg": "./src/icons/svg/icon-role.svg",
	"./icon-service.svg": "./src/icons/svg/icon-service.svg",
	"./icon-shanchu.svg": "./src/icons/svg/icon-shanchu.svg",
	"./icon-shezhi.svg": "./src/icons/svg/icon-shezhi.svg",
	"./icon-shopping.svg": "./src/icons/svg/icon-shopping.svg",
	"./icon-shoucang.svg": "./src/icons/svg/icon-shoucang.svg",
	"./icon-shoucangfill.svg": "./src/icons/svg/icon-shoucangfill.svg",
	"./icon-shouye.svg": "./src/icons/svg/icon-shouye.svg",
	"./icon-sousuo.svg": "./src/icons/svg/icon-sousuo.svg",
	"./icon-sql.svg": "./src/icons/svg/icon-sql.svg",
	"./icon-store.svg": "./src/icons/svg/icon-store.svg",
	"./icon-suoding.svg": "./src/icons/svg/icon-suoding.svg",
	"./icon-system.svg": "./src/icons/svg/icon-system.svg",
	"./icon-tixing.svg": "./src/icons/svg/icon-tixing.svg",
	"./icon-tubiao.svg": "./src/icons/svg/icon-tubiao.svg",
	"./icon-vip.svg": "./src/icons/svg/icon-vip.svg",
	"./icon-xiangqu.svg": "./src/icons/svg/icon-xiangqu.svg",
	"./icon-xiangqufill.svg": "./src/icons/svg/icon-xiangqufill.svg",
	"./icon-zhedie.svg": "./src/icons/svg/icon-zhedie.svg",
	"./icon-zonghe.svg": "./src/icons/svg/icon-zonghe.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/svg sync recursive \\.svg$";